<mat-dialog-content>
  <img [src]="safeImgSrc" [height]="imageHeight" />
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button mat-button color="primary" mat-dialog-close>{{ 'components.buttons.cancel' | translate}}</button>
  <button *ngIf="canShare()" mat-flat-button color="primary" (click)="share()">{{'components.buttons.share' | translate }}</button>
  <a *ngIf="!canShare() && canDownload()" [href]="safeImgSrc" target="_blank" download="Avatar.png" mat-flat-button color="primary">{{ 'components.buttons.download' |translate }}</a>
</mat-dialog-actions>